import { NewBadge } from '@/components/new-badge';

interface ItemInfoProps {
  name: string;
  description: string;
  totalPrice: number;
  isSoldOut?: boolean;
  isNew?: boolean;
}

export default function ItemInfo({ name, description, totalPrice, isSoldOut = false, isNew = false }: ItemInfoProps) {
  return (
    <section className="px-5 pt-5">
      {/* 상품명 */}
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-semibold text-gray-900 leading-[1.4]">{name}</h1>
          {isNew && <NewBadge />}
        </div>
        {isSoldOut && <span className="ml-2 px-2 py-1 bg-red-100 text-red-600 text-sm font-medium rounded">품절</span>}
      </div>

      {/* 설명 */}
      <p className="text-base font-medium text-gray-500 leading-[1.625] mb-4">{description}</p>

      {/* 가격 */}
      <div className="flex items-center justify-between">
        <span className="text-base font-semibold text-gray-900">가격</span>
        <div className="flex items-center gap-1">
          <span className="text-base font-semibold text-gray-900">{totalPrice.toLocaleString()}</span>
          <span className="text-base font-semibold text-gray-900">원</span>
        </div>
      </div>
    </section>
  );
}
